import { register, getPrefix } from '../../../Utils'

const LocationFilter = el => {
  const prefix = getPrefix(el)
  const placeholder = el.querySelector(`.${prefix}placeholder`)
  const placeholderFallback = placeholder.innerText
  const reset = el.querySelector(`.${prefix}reset`)
  const toggler = el.querySelector(`.${prefix}toggler`)
  const popup = el.querySelector(`.${prefix}popup`)
  const locations = el.querySelectorAll(`.${prefix}location`)

  const clickCompetence = (e) => {
    placeholder.innerText = e.target.innerText
    togglePopup()
  }

  locations.forEach(competence => {
    competence.addEventListener('click', clickCompetence)
  })

  const clickReset = () => {
    placeholder.innerText = placeholderFallback
    togglePopup()
  }

  reset.addEventListener('click', clickReset)

  const togglePopup = () => {
    popup.classList.toggle(`${prefix}is--active`)
  }

  toggler.addEventListener('click', togglePopup)
}

register('LocationFilter', LocationFilter)
